module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "ls-label"
  }, [_c('span', {
    staticClass: "ls-label-text col-xs-12"
  }, [_vm._v(_vm._s(_vm.$t('settings.label.webhook_setting')))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-7 col-sm-7 col-lg-7"
  }, [_c('div', {
    staticClass: "ls-custom-select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.$parent.$data.selectedWebhookSetting),
      expression: "$parent.$parent.$data.selectedWebhookSetting"
    }],
    staticClass: "ls-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$parent.$parent.$data.selectedWebhookSetting = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        $event.preventDefault();
        _vm.changeWebhookSetting()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v(_vm._s(_vm.$t('settings.webhook_attributes.invoice')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v(_vm._s(_vm.$t('settings.webhook_attributes.contract')))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75ce09d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/settings/components/SelectWebhookSetting.vue
// module id = 804
// module chunks = 1